import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import * as Api from "@/api";
import Search from "@/design/components/Search";
import useSearch from "@/utils/hooks/useSearch";
import Valkyrie, { viPerson, viXmark } from "@sippy-platform/valkyrie";

import { Alert, Box, Button, Drawer, IconButton, List, ListItem, ListItemText, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import AddMemberItem from "./AddMemberItem";

function IntercomMembers({ intercom, intercomDispatch }) {
  const userStore = useSelector((state) => state.domain.users);

  // Fetch data from API
  useEffect(() => {
    Promise.resolve(Api.getUsers());
  }, []);

  // Drawer
  const [drawer, setDrawer] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const searchResults = useSearch(userStore.list, searchValue, ["name", "exten"]);

  const closeDrawer = useCallback(() => {
    setDrawer(undefined);
    setSearchValue("");
  }, []);

  return (
    <>
      <Button onClick={() => setDrawer(true)} variant="contained" startIcon={<Valkyrie icon={viPerson} />}>
        Manage
      </Button>
      <Drawer
        open={!!drawer}
        onClose={() => closeDrawer()}
        anchor="right"
        slotProps={{
          paper: {
            sx: (theme) => ({ maxWidth: 320, width: 1, p: 1.5, display: "flex", gap: 1, ...theme.scrollbar }),
            elevation: 4,
          },
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Manage members</Typography>
          <IconButton onClick={() => closeDrawer()} color="inherit">
            <Valkyrie icon={viXmark} />
          </IconButton>
        </Stack>
        <Box sx={{ position: "sticky", top: 0, zIndex: 1000 }}>
          <Search blur value={searchValue} onChange={setSearchValue} />
        </Box>
        {intercom.members.length >= 15 && (
          <Alert severity="info" sx={{ mb: 1 }}>
            You have reached the limit of 15 members in this intercom.
          </Alert>
        )}
        <List>
          {searchResults.length >= 1 ? (
            searchResults.map((member) => (
              <AddMemberItem key={member.id} member={member} intercomDispatch={intercomDispatch} intercom={intercom} />
            ))
          ) : (
            <ListItem>
              <ListItemText primary="There are no users available..." />
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
}

IntercomMembers.propTypes = {
  intercom: PropTypes.object,
  intercomDispatch: PropTypes.func,
};

export default IntercomMembers;
